<template>
  <div class="vap-page">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="vap-page-header">
      <VasionButton
        id="btnBack"
        title="Back"
        :isDense="true"
        :icon="'arrow_back'"
        @vasionButtonClicked="backToWorkflowReport()"
      />
      <h1>{{ headerText }}</h1>
      <div class="btns-container">
        <VasionButton
          id="btnCreateReport"
          :classProp="'primary'"
          :isDisabled="disableSave"
          @vasionButtonClicked="saveReport()"
        >
          {{ saveButtonText }}
        </VasionButton>
      </div>
    </div>
    <div class="vap-page-content">
      <div class="md-layout">
        <div class="md-layout-item">
          <VasionInput
            id="report-name"
            v-model="reportName"
            width="300"
            class="input-style"
            inputType="top-white"
            title="REPORT NAME"
            required
          />
        </div>
      </div>
      <hr class="tabDivider">
      <div class="w100">
        <div class="innerTabDiv">
          <div>
            <VasionListSelection
              :available-fields.sync="availableUsers"
              :selected-fields.sync="accessUsers"
              :allow-field-ordering="false"
              :available-label-text="'Restricted Users'"
              :selected-label-text="'Access Users'"
              :unique-id="'access-users'"
            />
          </div>
          <div class="separator-div" />
          <div>
            <VasionListSelection
              :available-fields.sync="availableGroups"
              :selected-fields.sync="accessGroups"
              :allow-field-ordering="false"
              :available-label-text="'Restricted Groups'"
              :selected-label-text="'Access Groups'"
              :unique-id="'access-groups'"
            />
          </div>
        </div>
      </div>
    </div>
    <VasionSnackbar
      id="results-snack"
      :showSnackbarBool.sync="showSnackbar"
      :snackbarImage="snackbarImage"
      :snackbarSubTitle="snackbarSubTitle"
      :snackbarTitle="snackbarTitle"
    />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';

// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'

export default {
  components: {
    Loading,
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.common.bypassNavigationGuards) return next()
    
    if (to.name !== 'TheWorkflowReport') {
      this.$store.dispatch('reporting/setEditingWorkflowReport', false)
    }
    next()
  },
  data: function () {
    return {
      accessGroups: [],
      accessUsers: [],
      availableGroups: [],
      availableUsers: [],
      isLoading: false,
      loaderBackgroundColor,
      loaderColor,
      reportName: '',
      showSnackbar: false,
      snackbarImage: '',
      snackbarSubTitle: '',
      snackbarTitle: '',
    }
  },
  computed: {
    disableSave() { return this.reportName.length < 1 },
    editingWorkflowReport() { return this.$store.state.reporting.editingWorkflowReport },
    groups() { return this.$store.state.common.groups },
    headerText() { return 'Save Workflow Report' },
    saveButtonText() { return 'Save' },
    selectedReport() { return this.$store.state.reporting.selectedCustomReportConfig },
    users() { return this.$store.state.common.users },
    workflowReport() { return this.$store.state.reporting.workflowReport },
    workflowReportValues() { return this.$store.state.reporting.workflowReportData },
  },
  async created() {
    await Promise.all([
      this.$store.dispatch('common/getUsers'),
      this.$store.dispatch('common/getGroups'),
    ])

    this.loadUsersAndGroups()

     if (this.editingWorkflowReport) {
        this.setWorkflowReportValues()
    }
  },
  methods: {
    backToWorkflowReport() { this.$router.push({ name: 'TheWorkflowReport' }) },
    loadUsersAndGroups() {
      this.availableUsers = this.users.map((user) => {
        return {
          name: user.name,
          value: user.value,
        }
      })
      this.availableGroups = this.groups.map((group) => {
        return {
          name: group.name,
          value: group.value,
        }
      })
    },
    async saveReport() {
      this.isLoading = true
      const payload = this.workflowReportValues

      let validData = true
      if (this.reportName.trim() === '') {
        this.snackbarTitle = 'ERROR'
        this.snackbarSubTitle = 'Report Name must not include only spaces.'
        this.snackbarImage = false
        this.showSnackbar = true
        validData = false
      }

      if (validData) {
        payload.name = this.reportName
        payload.accessUserIDs = this.accessUsers.map(a => {
          return a.value
        }).filter(e => e != null)
        payload.accessGroupIDs = this.accessGroups.map(a => {
          return a.value
        }).filter(e => e != null)

        const response = await this.$store.dispatch('reporting/saveWorkflowReport', payload)
        if (response) {
          this.$store.dispatch('reporting/setEditingWorkflowReport', false)
          await this.$store.dispatch('reporting/getAllSavedWorkflowReports', true)
          this.$router.push({ name: 'TheSavedWorkflowReport', params: { workflowReportId: response.workflowReportID } })
        } else {
          this.showSnackbar = true
          this.snackbarTitle = 'ERROR'
          this.snackbarSubTitle = 'There was an error saving the workflow Report'
          this.snackbarImage = false
        }
      }
      this.isLoading = false
    },
    setWorkflowReportValues() {
      this.reportName = this.workflowReportValues.name
      this.workflowReportValues.accessUserIDs.forEach(id => {
        const user = this.availableUsers.find(a => a.value === id)
        this.accessUsers.push(user)
      })
      this.workflowReportValues.accessGroupIDs.forEach(id => {
        const group = this.availableGroups.find(a => a.value === id)
        this.accessGroups.push(group)
      })
      this.availableUsers = this.availableUsers.filter(a => {
        return !this.workflowReportValues.accessUserIDs.includes(a.value)
      })
      this.availableGroups = this.availableGroups.filter(a => {
        return !this.workflowReportValues.accessGroupIDs.includes(a.value)
      })
    },
  },
}
</script>

<style>
.alignRight {
  text-align: right;
}
.innerDiv {
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  width: 97%;
}
.tabDivider {
  border-style: solid;
  margin-top: 10px;
}
.w100 {
  width: 100%;
}
</style>
